import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { LimitsReminderAction } from "./limits-reminder.action";
import { LimitsReminderState } from "./limits-reminder.model";

const INITIAL_STATE: LimitsReminderState = {
	limitsSummary: undefined,
	limitsSummaryFetchError: undefined,
	lastGameId: undefined,
	limitsModalType: undefined,
};

export const limitsReminderReducer = createReducer(
	INITIAL_STATE,
	on(
		LimitsReminderAction.fetchBeforeLogoutSuccess,
		LimitsReminderAction.fetchLimitsSummarySuccess,
		LimitsReminderAction.fetchNotificationLimitsSummarySuccess,
		(state, { limitsSummary }) => updateState(state, { limitsSummary, limitsSummaryFetchError: false })
	),
	on(LimitsReminderAction.fetchBeforeLogoutFailure, LimitsReminderAction.fetchLimitsSummaryFailure, (state) =>
		updateState(state, { limitsSummaryFetchError: true })
	),
	on(LimitsReminderAction.updateLastGameId, (state, { gameId }) => updateState(state, { lastGameId: gameId })),
	on(LimitsReminderAction.clear, (state) => updateState(state, INITIAL_STATE)),
	on(LimitsReminderAction.showLimitsReminder, (state, { payload }) =>
		updateState(state, { limitsModalType: payload })
	)
);
